import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink border-t border-white/10" data-id="element-63" data-mp="3gfiv8kpoaff6">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center pt-[0px]" data-id="element-64" data-mp="3ghc0bvkn0rl2">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="32pfh6h0y5s0t">
          Sigma Smart<span className="align-super text-xs" data-id="element-66" data-mp="36qheutf7tw0o">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3ufa4k858v7mu">
          El sistema de gestión y ventas N°1 para lashistas de Argentina. Porque aplicar pestañas no
          debería costarte todos los turnos de la semana.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3le2iqpjwzz9n">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-rose-soft" data-id="element-69" data-mp="3qfjgwdb0l7mj">
            <MailIcon className="h-4 w-4 text-rose-soft" data-id="element-70" data-mp="2eyt7ymf7i1p8" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-rose-soft" data-id="element-71" data-mp="3l90mnssh4sxo">
            <InstagramIcon className="h-4 w-4 text-rose-soft" data-id="element-72" data-mp="3gb8x35faxiwn" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-rose-soft" data-id="element-73" data-mp="3v7zy1j4mj2od">
            <GlobeIcon className="h-4 w-4 text-rose-soft" data-id="element-74" data-mp="3q8dhazpl74at" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-rose-soft" data-id="element-75" data-mp="81yxik4n004i">
          “La próxima semana puede ser diferente.” 💅
        </p><div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="33nogbm61tnc">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="huwiqy10k36t">Términos y condiciones</a>
          <span data-id="element-78" data-mp="cuihpzxtxtia">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="qthyymj0j64f">Política de privacidad</a>
          <span data-id="element-80" data-mp="mrwqdddihe01">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="msg56l7v7m9u">Soporte</a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="tvmordarg8js">
          © 2026 Sigma Smart™ — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
        
      </div>
    </footer>;
}